import { forwardRef } from "react";

import {
  PILL_VARIANT_CLASS_MAP,
  type TPillProps,
} from "@/ui/components/primitives/Pill/Pill.config";
import { cn } from "@/ui/lib/utils";
import { TextControl } from "../../typography/TextControl";
import { Icon } from "../Icon";

export const Pill = forwardRef<HTMLDivElement, TPillProps>(
  (
    {
      className,
      variant,
      children,
      icon,
      ...props
    },
    ref,
  ) => (
    <div
      {...props}
      ref={ref}
      data-component="Pill"
      className={cn(
        "inline-flex gap-1 justify-center items-center border py-1 px-2",
        "rounded-full",
        PILL_VARIANT_CLASS_MAP[variant],
        className,
      )}
    >
      { icon ? (
        <Icon icon={icon} aria-hidden="true" size="sm" />
      ): null }
      <TextControl size={2} isResponsive={false}>{ children }</TextControl>
    </div>
  ),
); Pill.displayName = "Pill";
